import React from 'react';
import HelpCenter from 'views/HindiCCAMono';

const HelpCenterPage = () => {
  return <HelpCenter />;
};

export default HelpCenterPage;